import React from 'react'
import { Footer } from 'antd/es/layout/layout'
import { Row, Col } from 'antd'
import { useNavigate } from 'react-router'

export default function PublicFooterXS () {
  const navigate = useNavigate()

  return (
    <Footer className={'footer'} style={{ backgroundColor: '#1a3544', color: '#fff', padding: '24px 25px' }} >
      <Row>
        <Col span={16}>
          <img onClick={() => navigate('/')} style={{ cursor: 'pointer', marginRight: '1em' }} className="logo" src="/images/logo-lbm-footer.svg" alt='Logo' width="200px" />
        </Col>
        <Col span={8} style={{ display: 'grid' }}>
          <a style={{ color: '#FFF' }} href='https://laboxmedicale.fr/mentions-legales/' target='_blank' rel="noreferrer">Mentions légales</a>
          <a style={{ color: '#FFF' }} href='https://faq.laboxmedicale.com/'>FAQ</a>
        </Col>
      </Row>

      <Row style={{ margin: '1em 0' }}>
        <a href="mailto:contact@laboxmedicale.com">contact@laboxmedicale.com</a>
      </Row>
      <Row>
        <a style={cssCollectivité} href={'https://laboxmedicale.fr'} target='_blank' rel="noreferrer">Vous êtes une collectivité</a>
      </Row>
    </Footer>
  )
}

const cssCollectivité = {
  fontWeight: 'bold',
  borderWidth: '2px',
  borderColor: '#FFF',
  color: '#FFF',
  borderStyle: 'solid',
  borderRadius: '25px',
  padding: '0.5em 13px',
  cursor: 'pointer'
}
